export const fixIframeUrls = (html) => {
  return html.replace(/<iframe[^>]*src=["']([^"':]+)["']/gi, (match, src) => {
    const fixedSrc = src.startsWith("http") ? src : `https://${src}`;
    return match.replace(src, fixedSrc);
  });
};

export const fixInvalidLinks = (html) => {
  return html.replace(/<a([^>]*href=["']([^"']+)["'][^>]*)>/gi, (match, attributes, href) => {
    const isInvalidLink =
      !href ||
      href === "" ||
      href === "#" ||
      // eslint-disable-next-line no-script-url
      href === "javascript:void(0)" ||
      // eslint-disable-next-line no-script-url
      href === "javascript:;" ||
      // eslint-disable-next-line no-script-url
      (href.startsWith("javascript:") && href.length <= 12);

    const isValidAnchorLink = href && href.startsWith("#") && href.length > 1;

    if (isInvalidLink) {
      const cleanAttributes = attributes.replace(/href=["'][^"']*["']/gi, "");
      return `<a${cleanAttributes} onclick="event.preventDefault(); return false;" style="cursor: default; text-decoration: none; color: inherit;">`;
    }

    if (isValidAnchorLink) {
      const cleanAttributes = attributes.replace(/target=["'][^"']*["']/gi, "");
      return `<a${cleanAttributes}>`;
    }

    if (href.startsWith("http")) {
      return `<a${attributes} target="_blank" rel="noopener noreferrer">`;
    }

    if (href.startsWith("mailto:") || href.startsWith("tel:")) {
      return match;
    }

    return match;
  });
};

export const addSecurityTags = (html) => {
  const securityTags = `
      <base target="_self">
      <meta http-equiv="Content-Security-Policy" content="frame-ancestors 'self';">
    `;

  if (html.includes("<head>")) {
    return html.replace("<head>", `<head>${securityTags}`);
  } else if (html.includes("<html>")) {
    return html.replace("<html>", `<html><head>${securityTags}</head>`);
  } else {
    return `<head>${securityTags}</head>${html}`;
  }
};

export const addClickPrevention = (html) => {
  const preventionScript = `
      <script>
        document.addEventListener('DOMContentLoaded', function() {
          // Handle anchor links for smooth scrolling within the iframe
          var anchorLinks = document.querySelectorAll('a[href^="#"]');
          anchorLinks.forEach(function(link) {
            var href = link.getAttribute('href');
            
            // For valid anchor links with fragments, enable smooth scrolling
            if (href && href.length > 1 && href !== '#') {
              link.addEventListener('click', function(e) {
                e.preventDefault();
                var targetId = href.substring(1);
                var targetElement = document.getElementById(targetId);
                
                if (targetElement) {
                  targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                  });
                }
              });
            } else if (!href || href === '' || href === '#') {
              // Only prevent truly invalid links
              link.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                return false;
              });
              link.style.cursor = 'default';
              link.style.textDecoration = 'none';
            }
          });
          
          // Handle other invalid links
          var allLinks = document.querySelectorAll('a');
          allLinks.forEach(function(link) {
            var href = link.getAttribute('href');
            if (href === 'javascript:void(0)' || href === 'javascript:;') {
              link.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                return false;
              });
              link.style.cursor = 'default';
              link.style.textDecoration = 'none';
            }
          });
          
          // Prevent form submissions that might cause navigation issues
          var forms = document.querySelectorAll('form');
          forms.forEach(function(form) {
            if (!form.getAttribute('action') || form.getAttribute('action') === '#') {
              form.addEventListener('submit', function(e) {
                e.preventDefault();
                e.stopPropagation();
                return false;
              });
            }
          });
        });
      </script>
    `;

  return html.replace("</body>", `${preventionScript}</body>`);
};
